import { render, staticRenderFns } from "./WorkOrderForm.vue?vue&type=template&id=96156656&scoped=true"
import script from "./WorkOrderForm.vue?vue&type=script&lang=js"
export * from "./WorkOrderForm.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderForm.vue?vue&type=style&index=0&id=96156656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96156656",
  null
  
)

export default component.exports